import { Component } from "@angular/core";
import {
  ViewChild,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
} from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";

import { Subscription } from "rxjs/Rx";

import { TranslateService } from "@ngx-translate/core";

import { RootService } from "../../../service/root.service";

import { Project, MFields } from "../shared/project";
import { ProjectService } from "../shared/project.service";

import { ConfirmationService } from "primeng/primeng";

import { lightboot } from "../shared/lightbootstrap";
import { material } from "../shared/material";
import "codemirror/mode/javascript/javascript";
import "codemirror/mode/htmlmixed/htmlmixed";

@Component({
  selector: "project",
  templateUrl: "./project.component.html",
  styleUrls: ["./project.component.scss"],
})
export class ProjectComponent implements OnInit, OnDestroy {
  @Input() project: Project;
  @Input() id: number;
  @Input() operation: string;

  @ViewChild("formElement") formElement;
  @ViewChild("form") form;
  @Output() formSubmited = new EventEmitter();

  fromRoute: boolean;

  routeEvent: Subscription;
  requestXHR: Subscription;
  requestError: boolean;
  noResult: boolean;
  submittingForm: boolean = false;
  page = "setting";

  firstIndex = 0;
  lengthItems = 3;
  paginate(event) {
    this.firstIndex = event.first;
  }

  constructor(
    public rootService: RootService,
    public projectService: ProjectService,
    public confirmationService: ConfirmationService,
    public translate: TranslateService
  ) {
    this.onRemove(1);
    this.project = Object.assign({}, this.DefualtProject);
    rootService.tables = this.project.db.tables;
  }
  ngOnChanges() {
    if (this.operation == "read" || this.operation == "update") {
      if (!this.project.workflow) {
        this.addWorkflow();
      }
      if (typeof this.id !== "undefined") {
        this.getProject(+this.id);
      }
    } else {
      if (typeof this.id !== "undefined") {
        this.refreshRequest();
      }
    }
  }
  getProject(id: number) {
    this.project = null;
    this.requestError = false;
    this.noResult = false;
    if (this.requestXHR) {
      this.requestXHR.unsubscribe();
    }
    this.requestXHR = this.projectService.get(id).subscribe(
      (items) => {
        if (items.projects && items.projects.length > 0) {
          this.project = items.projects[0];
          this.rootService.tables = this.project.db.tables;
        } else {
          this.noResult = true;
        }
      }, //Bind to view
      (err) => {
        this.requestError = true;
        // Log errors if any
        this.rootService.toast.showErrorCode(err.code);
      }
    );
  }
  getClone(id: number) {
    this.project = null;
    this.requestError = false;
    this.noResult = false;
    if (this.requestXHR) {
      this.requestXHR.unsubscribe();
    }
    this.requestXHR = this.projectService.getClone(id).subscribe(
      (items) => {
        if (items.project) {
          this.project = items.project;
        } else {
          this.noResult = true;
        }
      }, //Bind to view
      (err) => {
        this.requestError = true;
        // Log errors if any
        this.rootService.toast.showErrorCode(err.code);
      }
    );
  }

  getInfo() {
    if (!this.project) {
      this.project = {};
    }
    this.requestError = false;
    this.noResult = false;
    if (this.requestXHR) {
      this.requestXHR.unsubscribe();
    }
    this.requestXHR = this.projectService.getInfo().subscribe(
      (items) => {}, //Bind to view
      (err) => {
        this.requestError = true;
        // Log errors if any
        this.rootService.toast.showErrorCode(err.code);
      }
    );
  }
  deleteProject() {
    this.confirmationService.confirm({
      message: this.translate.instant("form.common.deleteQ", {
        item: this.translate.instant("ctrl.project.view.header.one"),
      }),
      header: this.translate.instant("form.common.delete"),
      icon: "fa fa-trash",
      accept: () => {
        this.projectService.delete(this.project._id).subscribe(
          (items) => {
            this.rootService.toast.showSuccess(
              this.translate.instant("form.common.deleteItem", {
                item: this.translate.instant("ctrl.project.view.header.one"),
              })
            );
            this.formSubmited.emit(this.operation);
          }, //Bind to view
          (err) => {
            this.rootService.toast.showErrorCode(err.code);
          }
        );
      },
    });
  }

  removeArray(array, index) {
    array.splice(index, 1);
  }
  submitForm() {
    var formElement = this.formElement;
    var form = this.form;
    if (form.invalid) {
      var firstElement = formElement.nativeElement.querySelector(".ng-invalid");
      var focusElement = firstElement.querySelector(".focusV");
      if (focusElement) {
        focusElement.focus();
      }
      return;
    }
    if (this.submittingForm) {
      return;
    }
    this.submittingForm = true;
    if (this.operation == "create" || this.operation == "clone") {
      this.projectService.create(this.project).subscribe(
        (items) => {
          this.rootService.toast.showSuccess(
            this.translate.instant("form.common.createItem", {
              item: this.translate.instant("ctrl.project.view.header.one"),
            })
          );
          this.submittingForm = false;
          this.formSubmited.emit(this.operation);
        },
        (err) => {
          this.rootService.toast.showErrorCode(err.code);
          this.submittingForm = false;
        }
      );
    } else if (this.operation == "update") {
      this.projectService.update(this.id, this.project).subscribe(
        (items) => {
          this.rootService.toast.showSuccess(
            this.translate.instant("form.common.updateItem", {
              item: this.translate.instant("ctrl.project.view.header.one"),
            })
          );
          this.submittingForm = false;
          this.formSubmited.emit(this.operation);
        },
        (err) => {
          this.rootService.toast.showErrorCode(err.code);
          this.submittingForm = false;
        }
      );
    }
  }

  refreshRequest() {
    if (this.operation == "create") {
      this.getInfo();
    } else if (this.operation == "clone") {
      this.getClone(this.id);
    } else {
      this.getProject(this.id);
    }
  }
  ngOnInit() {
    if (typeof this.id !== "undefined" && this.id != null) {
      if (this.operation == "clone") {
        this.getClone(+this.id);
      } else {
        this.getProject(+this.id);
      }
    } else if (this.operation == "create") {
      this.getInfo();
    }
  }
  ngOnDestroy() {
    if (this.requestXHR) {
      this.requestXHR.unsubscribe();
    }
    if (this.routeEvent) {
      this.routeEvent.unsubscribe();
    }
  }

  addTableFromBox() {
    this.project.db.tables.push(JSON.parse(this.project.insertTable));
  }

  generateProject() {
    this.projectService.generate(this.project).subscribe(
      (items) => {
        this.rootService.toast.showSuccess("application generated");
      },
      (err) => {
        this.rootService.toast.showErrorCode(err.code);
      }
    );
  }

  panelItems: Array<MFields>;

  removeTable($event, i) {
    this.confirmationService.confirm({
      message: "Wanna DELETE the Table ?",
      header: "Delete Table '",
      icon: "fa fa-trash",
      accept: () => {
        this.project.db.tables.splice(i, 1);
      },
    });
    // var r = confirm("wanna delete the table");
    // if (r == true) {
    //     this.project.db.tables.splice(i, 1);
    // }
  }
  duplicateTable($event, i) {
    let newTable = Object.assign({}, $event);
    this.confirmationService.confirm({
      message: "Wanna Duplicate the table ?",
      header: "Duplicate Table '" + $event.name + "'",
      icon: "fa fa-copy",
      accept: () => {
        this.project.db.tables.push(newTable);
      },
    });
  }

  onRemove(event) {
    this.panelItems = [
      {
        name: "new",
        lang: [
          {
            name: "en",
            label: "",
            placeholder: "",
            options: [],
          },
          {
            name: "ar",
            label: "",
            placeholder: "",
            options: [],
          },
        ],
        vRequired: false,
        template: "item",
        type: "text",
        list: false,
        select: {
          name: "name",
          static: true,
          dynamic: true,
          table: "",
        },
        regex: "",
        preCode: "",
        postCode: "",
      },
      {
        name: "new",
        lang: [
          {
            name: "en",
            label: "",
            placeholder: "",
            options: [],
          },
          {
            name: "ar",
            label: "",
            placeholder: "",
            options: [],
          },
        ],
        vRequired: false,
        template: "container",
        type: "single",
        list: false,
        select: {
          name: "name",
          static: true,
          table: "",
        },
        fields: [],
        regex: "",
        preCode: "",
        postCode: "",
      },
    ];
  }

  addTheme() {
    this.project.module = {
      crud: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      list: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      crudR: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      listR: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      reportR: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      chartR: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
    };
    this.project.module.crud.html = material.crud.html;
    this.project.module.crud.js = material.crud.js;

    this.project.module.crud.css = material.crud.css;
    this.project.module.list.html = material.list.html;
    this.project.module.list.js = material.list.js;

    this.project.module.list.css = material.list.css;
    this.project.module.crudR.html = material.crudR.html;
    this.project.module.crudR.js = material.crudR.js;

    this.project.module.crudR.css = material.crudR.css;
    this.project.module.listR.html = material.listR.html;
    this.project.module.listR.js = material.listR.js;

    this.project.module.listR.css = material.listR.css;
    this.project.module.reportR.html = material.reportR.html;
    this.project.module.reportR.js = material.reportR.js;

    this.project.module.reportR.css = material.reportR.css;

    this.project.module.chartR.html = material.chartR.html;
    this.project.module.chartR.js = material.chartR.js;
    this.project.module.chartR.css = material.chartR.css;
  }

  addTable() {
    let newTable = {
      name: "newTable",
      lang: [
        {
          name: "en",
          header: {
            name: "en",
            title: "",
            navTitle: "",
            one: "",
            many: "",
            icon: "",
          },
          create: {
            name: "en",
            title: "Add ",
            navTitle: "Add",
            icon: "fas fa-plus-square",
          },
          update: {
            name: "en",
            title: "Update ",
            navTitle: "Update",
            icon: "fas fa-edit",
          },
          read: {
            name: "en",
            title: "View ",
            navTitle: "View",
            icon: "far fa-eye",
          },
          list: {
            name: "en",
            title: "List ",
            navTitle: "List",
            icon: "fas fa-list-ul",
          },
          clone: {
            name: "en",
            title: "Clone ",
            navTitle: "Clone",
            icon: "far fa-copy",
          },
        },
        {
          name: "ar",
          header: {
            name: "ar",
            title: "",
            navTitle: "",
            one: "",
            many: "",
            icon: "",
          },
          create: {
            name: "ar",
            title: "إضافة ",
            navTitle: "إضافة",
            icon: "fas fa-plus-square",
          },
          update: {
            name: "ar",
            title: "تحديث ",
            navTitle: "تحديث",
            icon: "fas fa-edit",
          },
          read: {
            name: "ar",
            title: "عرض ",
            navTitle: "عرض",
            icon: "far fa-eye",
          },
          list: {
            name: "ar",
            title: "قائمة ",
            navTitle: "قائمة",
            icon: "fas fa-list-ul",
          },
          clone: {
            name: "ar",
            title: "نسخ ",
            navTitle: "نسخ",
            icon: "far fa-copy",
          },
        },
      ],
      fields: [
        {
          template: "item",
          name: "name",
          type: "text",
          vRequired: true,
          list: true,
          fxFlexVal: "50%",
          select: {
            static: false,
            name: "",
            table: "",
          },
          lang: [
            {
              name: "en",
              label: "Name in English",
              placeholder: "Enter Name in English",
              options: [],
            },
            {
              name: "ar",
              label: "الأسم بالانجليزية",
              placeholder: "أدخل الأسم بالانجليزية",
              options: [],
            },
          ],
        },
        {
          template: "item",
          name: "nameAr",
          type: "text",
          vRequired: true,
          list: true,
          fxFlexVal: "50%",
          select: {
            static: false,
            name: "",
            table: "",
          },
          lang: [
            {
              name: "en",
              label: "Name in Arabic",
              placeholder: "Enter Name in Arabic",
              options: [],
            },
            {
              name: "ar",
              label: "الأسم بالعربية",
              placeholder: "أدخل الأسم بالعربية",
              options: [],
            },
          ],
        },

        {
          template: "item",
          name: "comments",
          type: "textarea",
          vRequired: false,
          list: false,
          fxFlexVal: "100%",
          select: {
            static: false,
            name: "",
            table: "",
          },
          lang: [
            {
              name: "en",
              label: "Comments",
              placeholder: "Enter Comments",
              options: [],
            },
            {
              name: "ar",
              label: "الملاحظات",
              placeholder: "أدخل الملاحظات",
              options: [],
            },
          ],
        },
      ],
      dynamic: true,
    };
    if (
      this.project.setting &&
      this.project.setting.enableSlug &&
      this.project.setting.enableSlug == true
    ) {
      newTable.fields.push(
        {
          template: "item",
          name: "slug",
          type: "text",
          vRequired: true,
          list: true,
          fxFlexVal: "50%",
          select: {
            static: false,
            name: "",
            table: "",
          },
          lang: [
            {
              name: "en",
              label: "Slug in English",
              placeholder: "Enter Slug in English",
              options: [],
            },
            {
              name: "ar",
              label: "سلق بالانجليزية",
              placeholder: "ادخل سلق بالانجليزية",
              options: [],
            },
          ],
        },
        {
          template: "item",
          name: "slugAr",
          type: "text",
          vRequired: false,
          list: true,
          fxFlexVal: "50%",
          select: {
            static: false,
            name: "",
            table: "",
          },
          lang: [
            {
              name: "en",
              label: "Slug in Arabic",
              placeholder: "Enter Slug in Arabic",
              options: [],
            },
            {
              name: "ar",
              label: "سلق بالعربية",
              placeholder: "أدخل سلق بالعربية",
              options: [],
            },
          ],
        }
      );
    }

    if (
      this.project.setting &&
      this.project.setting.appURL &&
      this.project.setting.apiURL
    ) {
      if (this.project.setting.appURL.slice(-1) !== "/")
        this.project.setting.appURL += "/";
      if (this.project.setting.apiURL.slice(-1) !== "/")
        this.project.setting.apiURL += "/";
    }
    this.project.db.tables.push(newTable);
  }

  addWorkflow() {
    if (!this.project.workflow || !this.project.workflow.WfConfig) {
      this.project.workflow = {
        WfConfig: {
          baseHref: "",
          liveBranch: "",
          liveBranch2: "",
          changeBranch: "",
          changeBranch2: "",
        },
      };
    }
  }

  DefualtProject: Project = {
    name: "",
    db: {
      name: "",
      tables: [
        {
          name: "role",
          lang: [
            {
              name: "en",
              header: {
                name: "en",
                title: "Roles",
                navTitle: "Role",
                one: "Role",
                many: "Roles",
                icon: "fas fa-cog",
              },
              create: {
                name: "en",
                title: "Add Role",
                navTitle: "Add",
                icon: "fas fa-plus-square",
              },
              update: {
                name: "en",
                title: "Update Role",
                navTitle: "Update",
                icon: "fas fa-edit",
              },
              read: {
                name: "en",
                title: "View Role",
                navTitle: "View",
                icon: "far fa-eye",
              },
              list: {
                name: "en",
                title: "Roles list",
                navTitle: "List",
                icon: "fas fa-list-ul",
              },
              clone: {
                name: "en",
                title: "Clone role",
                navTitle: "Clone",
                icon: "far fa-copy",
              },
            },
            {
              name: "ar",
              header: {
                name: "ar",
                title: "الصلاحيات",
                navTitle: "الصلاحيات",
                one: "الصلاحية",
                many: "الصلاحيات",
                icon: "fas fa-cog",
              },
              create: {
                name: "ar",
                title: "إضافة صلاحية",
                navTitle: "إضافة",
                icon: "fas fa-plus-square",
              },
              update: {
                name: "ar",
                title: "تحديث صلاحية",
                navTitle: "تحديث",
                icon: "fas fa-edit",
              },
              read: {
                name: "ar",
                title: "عرض صلاحية",
                navTitle: "عرض",
                icon: "far fa-eye",
              },
              clone: {
                name: "ar",
                title: "نسخ صلاحية",
                navTitle: "نسخ",
                icon: "far fa-copy",
              },
              list: {
                name: "ar",
                title: "قائمة الصلاحيات",
                navTitle: "قائمة",
                icon: "fas fa-list-ul",
              },
            },
          ],
          fields: [
            {
              template: "item",
              name: "name",
              type: "text",
              vRequired: true,
              list: true,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Name",
                  placeholder: "Enter name",
                  options: [],
                },
                {
                  name: "ar",
                  label: "الأسم",
                  placeholder: "أدخل الأسم",
                  options: [],
                },
              ],
            },
            {
              name: "group",
              lang: [
                {
                  name: "en",
                  label: "Group",
                  placeholder: "Select Group",
                  options: [
                    {
                      _id: 1,
                      label: "Admin",
                    },
                    {
                      _id: 2,
                      label: "Public",
                    },
                  ],
                },
                {
                  name: "ar",
                  label: "المجموعة",
                  placeholder: "اختر المجموعة",
                  options: [
                    {
                      _id: 1,
                      label: "مدير النظام",
                    },
                    {
                      _id: 2,
                      label: "عام",
                    },
                  ],
                },
              ],
              vRequired: true,
              template: "item",
              type: "select",
              list: true,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              template: "item",
              name: "permission",
              type: "text",
              vRequired: false,
              list: false,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Permission",
                  placeholder: "Permission",
                  options: [],
                },
                {
                  name: "ar",
                  label: "الصلاحيات",
                  placeholder: "الصلاحيات",
                  options: [],
                },
              ],
            },
          ],
        },
        {
          name: "user",
          lang: [
            {
              name: "en",
              header: {
                name: "en",
                title: "User",
                navTitle: "User",
                one: "user",
                many: "users",
                icon: "far fa-user",
              },
              create: {
                name: "en",
                title: "Add User",
                navTitle: "Add",
                icon: "fas fa-plus-square",
              },
              update: {
                name: "en",
                title: "Update User",
                navTitle: "Update",
                icon: "fas fa-edit",
              },
              read: {
                name: "en",
                title: "View User",
                navTitle: "View",
                icon: "far fa-eye",
              },
              list: {
                name: "en",
                title: "List Users",
                navTitle: "List",
                icon: "fas fa-list-ul",
              },
              clone: {
                name: "en",
                title: "Clone user",
                navTitle: "Clone",
                icon: "far fa-copy",
              },
            },
            {
              name: "ar",
              header: {
                name: "ar",
                title: "مستخدم",
                navTitle: "مستخدم",
                one: "مستخدم",
                many: "مستخدمين",
                icon: "far fa-user",
              },
              create: {
                name: "ar",
                title: "إضافة مستخدم",
                navTitle: "إضافة",
                icon: "fas fa-plus-square",
              },
              update: {
                name: "ar",
                title: "تحديث المستخدم",
                navTitle: "تحديث",
                icon: "fas fa-edit",
              },
              read: {
                name: "ar",
                title: "عرض المستخدم",
                navTitle: "عرض",
                icon: "far fa-eye",
              },
              clone: {
                name: "ar",
                title: "نسخ المستخدم",
                navTitle: "نسخ",
                icon: "far fa-copy",
              },
              list: {
                name: "ar",
                title: "قائمة المستخدمين",
                navTitle: "قائمة",
                icon: "fas fa-list-ul",
              },
            },
          ],
          fields: [
            {
              template: "item",
              name: "name",
              type: "text",
              vRequired: true,
              list: true,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Display name",
                  placeholder: "Enter display name",
                  options: [],
                },
                {
                  name: "ar",
                  label: "الأسم",
                  placeholder: "ادخل الأسم",
                  options: [],
                },
              ],
            },
            {
              template: "item",
              name: "email",
              type: "email",
              vRequired: true,
              list: true,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Email",
                  placeholder: "Enter email",
                  options: [],
                },
                {
                  name: "ar",
                  label: "البريد الألكتروني",
                  placeholder: "أدخل البريد الألكتروني",
                  options: [],
                },
              ],
            },
            {
              template: "item",
              name: "username",
              type: "text",
              vRequired: true,
              list: false,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Username",
                  placeholder: "Enter username",
                  options: [],
                },
                {
                  name: "ar",
                  label: "أسم المستخدم",
                  placeholder: "أدخل أسم المستخدم",
                  options: [],
                },
              ],
            },
            {
              template: "item",
              name: "password",
              type: "password",
              vRequired: true,
              list: false,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Password",
                  placeholder: "enter password",
                  options: [],
                },
                {
                  name: "ar",
                  label: "كلمة المرور",
                  placeholder: "أدخل كلمة المرور",
                  options: [],
                },
              ],
            },
            {
              template: "item",
              name: "profileImg",
              type: "mediaGallery",
              vRequired: false,
              list: false,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Profile image",
                  placeholder: "Profile image",
                  options: [],
                },
                {
                  name: "ar",
                  label: "الصور الشخصية",
                  placeholder: "أدخل الصور الشخصية",
                  options: [],
                },
              ],
            },
            {
              template: "item",
              name: "active",
              type: "yes-no",
              vRequired: false,
              list: false,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Active",
                  placeholder: "Active",
                  options: [],
                },
                {
                  name: "ar",
                  label: "مفعل",
                  placeholder: "مفعل",
                  options: [],
                },
              ],
            },
            {
              template: "item",
              name: "role",
              type: "select",
              vRequired: true,
              list: false,
              select: {
                static: false,
                name: "roles",
                table: "role",
              },
              lang: [
                {
                  name: "en",
                  label: "Role",
                  placeholder: "Select role",
                  options: [],
                },
                {
                  name: "ar",
                  label: "الدور",
                  placeholder: "أختار الدور",
                  options: [],
                },
              ],
            },
            {
              template: "item",
              name: "fcmToken",
              type: "text",
              vRequired: false,
              list: false,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "fcmToken",
                  placeholder: "Enter fcmToken",
                  options: [],
                },
                {
                  name: "ar",
                  label: "رمز الفايربيس",
                  placeholder: "أدخل رمز الفايربيس",
                  options: [],
                },
              ],
            },
          ],
          dynamic: true,
        },
        {
          name: "gallery",
          lang: [
            {
              name: "en",
              header: {
                name: "en",
                title: "Media Gallery",
                navTitle: "media gallery",
                one: "Media",
                many: "Medias",
                icon: "far fa-images",
              },
              create: {
                name: "en",
                title: "Add Media",
                navTitle: "Add",
                icon: "fas fa-plus-square",
              },
              update: {
                name: "en",
                title: "Update Media",
                navTitle: "Update",
                icon: "fas fa-edit",
              },
              read: {
                name: "en",
                title: "View Media",
                navTitle: "View",
                icon: "far fa-eye",
              },
              list: {
                name: "en",
                title: "List ",
                navTitle: "List",
                icon: "fas fa-list-ul",
              },
              clone: {
                name: "en",
                title: "Clone Media",
                navTitle: "Clone",
                icon: "far fa-copy",
              },
            },
            {
              name: "ar",
              header: {
                name: "ar",
                title: "استيديو الصور",
                navTitle: "استيديو الصور",
                one: "ميديا",
                many: "ميديا",
                icon: "far fa-images",
              },
              create: {
                name: "ar",
                title: "إضافة ",
                navTitle: "إضافة",
                icon: "fas fa-plus-square",
              },
              update: {
                name: "ar",
                title: "تحديث ",
                navTitle: "تحديث",
                icon: "fas fa-edit",
              },
              read: {
                name: "ar",
                title: "عرض ",
                navTitle: "عرض",
                icon: "far fa-eye",
              },
              list: {
                name: "ar",
                title: "قائمة ",
                navTitle: "قائمة",
                icon: "fas fa-list-ul",
              },
              clone: {
                name: "ar",
                title: "نسخ ",
                navTitle: "نسخ",
                icon: "far fa-copy",
              },
            },
          ],
          fields: [
            {
              name: "img",
              lang: [
                {
                  name: "en",
                  label: "Upload Image",
                  placeholder: "upload an image",
                  options: [],
                },
                {
                  name: "ar",
                  label: "ارفاق صورة",
                  placeholder: "ارفق صورة",
                  options: [],
                },
              ],
              vRequired: true,
              template: "item",
              type: "file",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              template: "item",
              name: "name",
              type: "text",
              vRequired: true,
              list: true,
              select: {
                static: false,
                name: "",
                table: "",
              },
              lang: [
                {
                  name: "en",
                  label: "Name",
                  placeholder: "Enter name",
                  options: [],
                },
                {
                  name: "ar",
                  label: "الأسم",
                  placeholder: "أدخل الأسم",
                  options: [],
                },
              ],
            },
            {
              name: "type",
              lang: [
                {
                  name: "en",
                  label: "image type",
                  placeholder: "Enter Image Type",
                  options: [],
                },
                {
                  name: "ar",
                  label: "نوع الصورة",
                  placeholder: "ادخل نوع الصورة",
                  options: [],
                },
              ],
              vRequired: true,
              template: "item",
              type: "text",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              name: "size",
              lang: [
                {
                  name: "en",
                  label: "Size",
                  placeholder: "Enter size",
                  options: [],
                },
                {
                  name: "ar",
                  label: "حجم",
                  placeholder: "ادخل حجم الصورة",
                  options: [],
                },
              ],
              vRequired: true,
              template: "item",
              type: "text",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              name: "width",
              lang: [
                {
                  name: "en",
                  label: "Image Width",
                  placeholder: "Enter Image Width",
                  options: [],
                },
                {
                  name: "ar",
                  label: "عرض الصورة",
                  placeholder: "ادخل عرض الصورة",
                  options: [],
                },
              ],
              vRequired: true,
              template: "item",
              type: "text",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              name: "height",
              lang: [
                {
                  name: "en",
                  label: "Image Height ",
                  placeholder: "Enter Image Height",
                  options: [],
                },
                {
                  name: "ar",
                  label: "طول الصورة",
                  placeholder: "ادخل طول الصورة",
                  options: [],
                },
              ],
              vRequired: true,
              template: "item",
              type: "text",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              name: "alt",
              lang: [
                {
                  name: "en",
                  label: "Image alt",
                  placeholder: "Enter Image alt",
                  options: [],
                },
                {
                  name: "ar",
                  label: "ألت",
                  placeholder: "ألت",
                  options: [],
                },
              ],
              vRequired: true,
              template: "item",
              type: "text",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              name: "altAr",
              lang: [
                {
                  name: "en",
                  label: "Image alt",
                  placeholder: "Enter Image alt",
                  options: [],
                },
                {
                  name: "ar",
                  label: "ألت",
                  placeholder: "ألت",
                  options: [],
                },
              ],
              vRequired: true,
              template: "item",
              type: "text",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              name: "caption",
              lang: [
                {
                  name: "en",
                  label: "Image caption",
                  placeholder: "Enter Image Caption",
                  options: [],
                },
                {
                  name: "ar",
                  label: "شرح الصورة",
                  placeholder: "ادخل شرح الصورة",
                  options: [],
                },
              ],
              vRequired: false,
              template: "item",
              type: "text",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
            {
              name: "captionAr",
              lang: [
                {
                  name: "en",
                  label: "Image caption",
                  placeholder: "Enter Image Caption",
                  options: [],
                },
                {
                  name: "ar",
                  label: "شرح الصورة",
                  placeholder: "ادخل شرح الصورة",
                  options: [],
                },
              ],
              vRequired: false,
              template: "item",
              type: "text",
              list: false,
              select: {
                name: "name",
                static: true,
                dynamic: true,
                table: "",
              },
              regex: "",
              preCode: "",
              postCode: "",
            },
          ],
          dynamic: true,
          customControllerD:
            "public function uploadImg()   \n {   \n     $data = new stdClass();  \n      $file = $this->_model->createImg($data);    \n    $message = array(     \n       'url' => $file['fullRecord']->url,    \n        $file   \n      );    \n    return json_encode($message, JSON_UNESCAPED_UNICODE);  \n  }",
          customController: "",
          customModelD:
            "public function createImg($data)   \n {    \n    global $USER;    \n    $collection = 'gallery';     \n   if (isset($data->_id)) {   \n         unset($data->_id);  \n      }  \n      $gallery = new Gallery_t($data);    \n    $image_info = FieldType::imgUpload($gallery->_id, $collection);    \n    if (isset($USER['id'])) {     \n       $gallery->createdBy = FieldType::ref($USER['id'] * 1, 'user');  \n      }        $dt = new DateTime();    \n    $gallery->createdDate = $dt->format('U') * 1000;    \n    $gallery->deleted = 0;   \n     $gallery->name = $image_info['image_name'];   \n     $gallery->size = $image_info['image_size'];    \n    $gallery->type = $image_info['image_ext'];   \n     $gallery->width = $image_info['image_width'];    \n    $gallery->height = $image_info['image_height'];   \n     $gallery->url = $image_info['url'];   \n     $this->db->insert($collection, $gallery);    \n    $result = $this->db->run();   \n     $array = [];    \n    $array['gallery'] = ['id' => $gallery->_id];    \n    $array['fullRecord'] = $gallery;   \n     return $array;  \n  }",
          customModel: "",
        },
      ],
    },
    setting: {
      folderName: "",
      titleEn: "",
      titleAr: "",
      ver: "",
      apiURL: "",
      appURL: "",
      enableSlug: false,

      db: {
        host: "",
        port: "",
        name: "",
        username: "",
        password: "",
      },
      email: {
        host: "",
        auth: false,
        port: "",
        displayName: "",
        username: "",
        password: "",
      },
    },
    workflow: {
      WfConfig: {
        baseHref: "",
        liveBranch: "",
        changeBranch: "",
        liveBranch2: "",
        changeBranch2: "",
      },
    },
    module: {
      crud: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      list: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      crudR: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      listR: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
      reportR: {
        html: "",
        css: "",
        js: "",
        jsD: "",
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/module/project/project/project.component.ts